import { useParams, useNavigate } from 'react-router-dom';
import { useGetPatientDetails } from 'src/hooks/patient';
import { PatientDetailsBar } from './detailsBar';
import { PatientTimeline } from './timeline';
import { BarsLoader } from '@insight-health-ai/roseate/components';
import { ChevronLeft } from '@insight-health-ai/roseate/icons';
import { Card, Divider, Tooltip } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { addPatientToRecentlyViewed } from 'src/utils';
import { useAuth } from '@frontegg/react';
import { analytics } from 'src/services';
import { usePageHeader } from 'src/hooks/misc';

export const PatientDetails = () => {
  const navigate = useNavigate();
  const { patientId } = useParams();
  const { data, isLoading, error } = useGetPatientDetails({
    patientId: patientId!,
  });

  usePageHeader({
    title: 'Patient Details',
    breadcrumb: [
      { icon: <ChevronLeft />, title: 'Search Patients', href: '/patients' },
    ],
  });

  const { user } = useAuth();

  useEffect(() => {
    if (data) {
      addPatientToRecentlyViewed({
        orgId: user?.tenantId!,
        patient: data,
      });
    }
  }, [data]);

  const getChildren = () => {
    if (isLoading) {
      return (
        <div className="flex justify-center items-center h-full">
          <BarsLoader size="md" />
        </div>
      );
    }

    if (error || !data) {
      return (
        <div className="text-center text-gray-500">Something went wrong</div>
      );
    }

    return (
      <>
        <Card
          className="shadow"
          styles={{
            body: {
              padding: 0,
            },
          }}
        >
          <PatientDetailsBar
            firstName={data.first_name}
            lastName={data.last_name}
            id={data.patient_id}
            dob={data.birth_date}
            pastAppointment={data.past_appointment_date}
            nextAppointment={data.next_appointment_date}
            email={data.email?.email_text}
            phone={data.phone?.phone_text}
            ehrId={data.ehr_id}
            extras={
              <Tooltip title="Search for different patient">
                <CloseOutlined
                  className="hover:bg-gray-100 rounded-full p-1"
                  onClick={() => {
                    analytics.track('Closed Patient Details', {
                      email: user?.email,
                      patient_id: data.patient_id,
                    });
                    navigate('/patients');
                  }}
                />
              </Tooltip>
            }
          />
        </Card>
        <div className="px-1 flex flex-col">
          <Divider>
            <span className="text-gray-500">Timeline</span>
          </Divider>
          <PatientTimeline patient={data!} />
        </div>
      </>
    );
  };

  return (
    <div
      className="page-wrapper care-connect-page flex flex-col gap-2 h-full"
      style={{ height: 'calc(100dvh - 100px)' }}
    >
      {getChildren()}
    </div>
  );
};
